module.exports = __webpack_public_path__ + "img/info_icon.37dc2b96.svg";